import React from "react";
import { ChartContainer } from "@mui/x-charts/ChartContainer";
import { ChartsXAxis } from "@mui/x-charts/ChartsXAxis";
import { ChartsYAxis } from "@mui/x-charts/ChartsYAxis";
import { ChartsTooltip } from "@mui/x-charts/ChartsTooltip";
import { ChartsLegend } from "@mui/x-charts/ChartsLegend";
import { BarPlot, LinePlot, MarkPlot, AreaPlot } from "@mui/x-charts";

// Datos de ejemplo para las fechas mostradas (11 ene - 8 feb, simplificado)
const dataset = [
  { fecha: "11 ene", gasto: 16000, roas: 1000, ventas: 45000 },
  { fecha: "13 ene", gasto: 17500, roas: 1.9, ventas: 48000 },
  { fecha: "15 ene", gasto: 22000, roas: 2.3, ventas: 44000 },
  { fecha: "17 ene", gasto: 19500, roas: 2.1, ventas: 58000 },
  { fecha: "19 ene", gasto: 21000, roas: 1.5, ventas: 42000 },
  { fecha: "21 ene", gasto: 18000, roas: 1.9, ventas: 56000 },
  { fecha: "23 ene", gasto: 23500, roas: 2.1, ventas: 58000 },
  { fecha: "25 ene", gasto: 24000, roas: 2.0, ventas: 46000 },
  { fecha: "27 ene", gasto: 22500, roas: 2.3, ventas: 54000 },
  { fecha: "29 ene", gasto: 18500, roas: 1.8, ventas: 56000 },
];

// Configuración de las series
const seriesConfiguration = [
  {
    type: "bar",
    dataKey: "gasto",
    label: "Gasto ($)",
    color: "#3B82F6",
    yAxisId: "gasto-axis",
    valueFormatter: (value) => `$${value.toLocaleString()}`,
  },
  {
    type: "line",
    dataKey: "roas",
    label: "ROAS",
    color: "#8B5CF6",
    yAxisId: "roas-axis",
    showMark: true,
    valueFormatter: (value) => `${value.toFixed(1)}x`,
  },
  {
    id: "ventas",
    type: "line",
    dataKey: "ventas",
    label: "Ventas Totales",
    color: "#A1A1AA",
    yAxisId: "gasto-axis",
    area: true,
    showMark: false,
    valueFormatter: (value) => `$${value.toLocaleString()}`,
  },
];

export default function PerformanceChart() {
  return (

      <ChartContainer
        width={1000}
        height={400}
        dataset={dataset}
        series={seriesConfiguration}
        xAxis={[{ dataKey: "fecha", scaleType: "band" }]}
        yAxis={[
          // Eje Izquierdo para Gasto ($)
          {
            id: "gasto-axis",
            scaleType: "linear",
            orientation: "left",
            min: 0,
            label: "Gastos ($)",
          },
          // Eje Derecho para ROAS
          {
            id: "roas-axis",
            scaleType: "linear",
            orientation: "right",
            min: 0,
            max: 4,
            label: "ROAS",
          },
        ]}
        margin={{ left: 110, right: 100, top: 20, bottom: 60 }}
      >
        {/* Gradiente para el área de ventas */}
        <defs>
          <linearGradient id="ventasGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#D1D5DB" stopOpacity={0.302} />
            <stop offset="100%" stopColor="#D1D5DB" stopOpacity={0.051} />
          </linearGradient>
          <style>{`.MuiAreaElement-series-ventas { fill: url(#ventasGradient) !important; }`}</style>
        </defs>

        {/* Ventas totales al fondo */}
        <AreaPlot
          sx={{ "& .MuiAreaElement-root": { fill: "url(#ventasGradient) !important" } }}
        />
        {/* Barras de gasto con esquinas redondeadas */}
        <BarPlot slotProps={{ bar: { rx: 4, ry: 4 } }} />
        {/* Líneas encima */}
        <LinePlot />
        {/* Renderizamos los puntos de las líneas */}
        <MarkPlot />

        {/* Componentes visuales adicionales */}
        <ChartsXAxis />
        <ChartsYAxis yAxisId="gasto-axis" tickSize={6} label="Gasto ($)" labelStyle={{ translate: "-30px" }} />
        <ChartsYAxis yAxisId="roas-axis" position="right" tickSize={6} label="ROAS" labelStyle={{ translate: "30px" }} />

        <ChartsTooltip />

        {/* Leyenda en la parte inferior */}
        <ChartsLegend
          position={{ vertical: "bottom", horizontal: "middle" }}
          direction="row"
          slotProps={{ legend: { labelStyle: { fontSize: 12 } } }}
        />
      </ChartContainer>
  );
}
